import React from "react";
import { calculateSwimBlockMeters, getSwimIntensityDistribution } from "../../domain/swimming/calculations";

const SwimBlockSummary = ({ block }) => {
    const meters = calculateSwimBlockMeters(block);
    const distribution = getSwimIntensityDistribution(block?.sets || []);

    return (
        <div className="swim-block-summary">
            <div className="swim-block-summary-main">
                <span className="text-muted">Volume do bloco</span>
                <strong>{meters.toLocaleString("pt-BR")} m</strong>
            </div>
            <div className="swim-zone-list">
                {distribution.length === 0 ? (
                    <span className="text-muted font-size-11">Sem zonas definidas</span>
                ) : (
                    distribution.map(item => (
                        <span key={item.zone} className="swim-zone-pill">
                            {item.zone}: {item.meters.toLocaleString("pt-BR")}m ({item.percent}%)
                        </span>
                    ))
                )}
            </div>
        </div>
    );
};

export default SwimBlockSummary;
